import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PageableTableComponent } from '../../shared/controls/pageable-table/pageable-table.component';

import { ToastService } from '../../shared/toast/toast.service';
import { ErrorService } from '../../shared/services/error-service';
import { InitializerService } from '../../shared/services/initializer-service';

import { PopiManagerService, PagingData, PopiDeidentifyRequest } from '../../../service/proxy';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    templateUrl: './popi.component.html',
    styleUrl: './popi.component.scss',

    imports: [
        CommonModule,
        FormsModule,
        PageableTableComponent
    ],

    providers: [
        PopiManagerService
    ]
})
export class PopiComponent {
    public search: string = '';
    public paging: PagingData;
    public popiResults: any[] = [];
    public popiRefId: string = '';
    public submittedPopiRefId: string = '';

    public refreshInProgress = false;

    constructor(
        private popiService: PopiManagerService,
        private toastService: ToastService,
        private errorService: ErrorService,
        private initializerService: InitializerService,
        private cdr: ChangeDetectorRef)
    {
        this.paging = this.initializerService.createPagingData();
    }

    getPopiResults(pagingData: PagingData): void {
        if (this.refreshInProgress) {
            return;
        }

        this.refreshInProgress = true;
        pagingData.pageSize = 100;

        this.popiService.searchPopiData(
            this.search,
            pagingData.pageNo,
            pagingData.pageSize,
            this.popiRefId
        )
        .subscribe({
            next: (data) => {
                console.log('data', data);
                this.paging = data.pagingData;
                this.popiResults = data.results || [];
                this.refreshInProgress = false;
                this.cdr.detectChanges();
            },
            error: (error) => {
                this.errorService.handleError(error);
                this.refreshInProgress = false;
            }
        });
    }

    searchPopi(): void {

        if (!this.search) {
            this.toastService.show('Please enter a search term.', 'warning');
            return;
        }

        this.submittedPopiRefId = this.popiRefId;
        this.getPopiResults(this.paging);
    }

    deidentifyRecord(item: any): void {
        const tableName = item.table;
        const recordId = item?.id;
        const dbName = item?.dbName;
        if (!recordId || !tableName) {
            this.toastService.show('Invalid record selected for de-identification.', 'error');
            return;
        }

        if (!this.popiRefId) {
            this.toastService.show('POPI Reference ID is required before de-identification.', 'warning');
            return;
        }

        const request = new PopiDeidentifyRequest({
            tableName,
            recordId,
            popiReferenceId: this.popiRefId,
            dbName
        });

        this.popiService.deidentifyPopiRecord(request).subscribe({
            next: (result) => {
                this.toastService.show(`Record de-identified. POPI Ref: ${result.popiReferenceId}`, 'success');
                this.searchPopi();
            },
            error: (error) => {
                this.errorService.handleError(error);
            }
        });
    }

    deidentifyWrap(result: any, item: any): any {
        const id = item;
        return {
            id: id,
            table: result.table,
            dbName: result.dbName
        };
    }

    onRefreshPopi(pagingData: PagingData): void {
        if (this.refreshInProgress) {
            return;
        }

        this.refreshInProgress = true;
        setTimeout(() => this.refreshInProgress = false, 500);

        this.paging = pagingData;
        this.getPopiResults(this.paging);
    }

    getPagingDataFor(items: any[]): PagingData {
        const paging = new PagingData();

        paging.recordCount = items.length;
        paging.pageNo = 1;
        paging.pageSize = 10;

        return paging;
    }

    getColumnsFor(result: any): { [key: string]: string } {
        if (!result?.records?.length) {
            return {};
        }

        const sample = result.records[0]; // Use the first record to extract keys
        const keys = Object.keys(sample);
        const map: { [key: string]: string } = {};

        for (const key of keys) {
            const pretty = this.prettyPrint(key);
            map[key] = pretty;
        }

        return map;
    }

    prettyPrint(str: string): string {
        return str
            .replace(/([A-Z])/g, ' $1')  // Add space before caps
            .replace(/^./, s => s.toUpperCase()); // Capitalize first letter
    }
}
